import {Rosters, Superstars} from "./models.js";

function Gimmick() {

    // Float
    const effectiveness = null;

    // Integer
    const startMonth = null;
    const startYear = null;
    const endMonth = null;
    const endYear = null;
    const combinationBonus = 0;
    const characterBonus = 0;

    // Strings
    const name = null;

    // Boolean
    const nextGimmickBoost = false;

    // Foreign keys
    const superstarId = null;
    const character = null;
    const rosterId = null;

    return {
        effectiveness,
        startMonth,
        startYear,
        endMonth,
        endYear,
        combinationBonus,
        characterBonus,
        name,
        nextGimmickBoost,
        superstarId,
        character,
        rosterId,
    };
}

function getGimmickSuperstar(gimmick) {
    return Superstars.find({'$loki': gimmick.superstarId})[0];
}

function getGimmickRoster(gimmick) {
    return Rosters.find({'$loki': gimmick.rosterId})[0];
}

export { Gimmick, getGimmickSuperstar, getGimmickRoster }
